<script>
export default {
    name: "DocumentManagementModal",

    data() {

        return {
          upload: {
                patientID: this.$route.params.patientID,
                visitNo: 0,
                userName: this.$root.username,
                file: '',
            },
        };
    },

    props: {

        showModal: Boolean,
    },

    methods: {

        parseFile() {

            this.upload.file = this.$refs.file.files[0];
        },

        saveData() {
            this.$root.loading = true;
            const formData = new FormData();
            formData.append('file', this.upload.file);
            let url = `Files/PostPatientDocument`;
                url += `?PatientID=${this.$route.params.patientID}&VisitNo=${this.upload.visitNo}`;
                url += `&DocRef=${this.upload.docRef}&DocName=${this.upload.docName}`;
                url += `&Description=patient file&UserName=${this.$root.username}`;

            this.$http.post(url, formData).then(response => {
                 this.upload = {
                     patientID: this.$route.params.patientID,
                     visitNo: 0,
                     userName: this.$root.username,
                     file: '',
                 };
                 this.$emit('refresh');
                 this.$emit('closeModal');
                 this.$root.loading = false;
                 window.Swal.fire({ text: response.data, type: 'success' });
            }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="sm:11/12 md:w-1/2">
  <template v-slot:title>
    <h5 class="text-base font-bold">Add document</h5>
  </template>
    <template v-slot:modal-body>
        <div class="flex flex-wrap">
            <div class="md:w-1/3 sm:w-full p-tiny">
                <label for="grid-document-ref" class="label-control">Doc Ref:</label>
                <input type="text" 
                    v-model.trim="upload.docRef" 
                    id="grid-document-ref" 
                    class="input-sm input-control text-tiny">
            </div>
            <div class="md:w-1/3 sm:w-full p-tiny">
                <label for="grid-name-file" class="label-control">Name:</label>
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-name-file" 
                            v-model.trim="upload.docName" 
                            class="input-control input-sm text-xs">
                            <option value="ID">ID</option>
                            <option value="Birth Certficate">Birth Certficate</option>
                            <option value="Passport">Passport</option>
                            <option value="Insurance Doc">Insurance Doc</option>
                        </select>
                    </template>
                </tail-select>
            </div>
            <div class="md:w-1/3 sm:w-full p-tiny">
                <label for="grid-doc-management-file" class="label-control">Attach file:</label>
                <input type="file" 
                    accept=".pdf" ref="file" 
                    id="grid-doc-management-file" 
                    @change="parseFile" 
                    class="input-sm input-control text-tiny">
            </div>
        </div>
    </template>
    <template v-slot:modal-footer>
      <button class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit('closeModal')">
            <i class="fa fa-times"></i> Cancel</button>
      <button class="btn-primary btn-sm text-xs rounded" 
        @click.prevent="saveData">
            <i class="fa fa-save"></i> Save</button>
    </template>
</tail-modal>
</template>